import { SCENE_STORAGE, DEVICE_STATUS, ERROR_HANDLE } from "../types/index";

const storageScene = (data) => {
  return {
    type: SCENE_STORAGE,
    scene: data,
  };
};

const deviceStatus = (data) => {
  return {
    type: DEVICE_STATUS,
    status: data,
  };
};

const errorHandle = (data) => {
  return {
    type: ERROR_HANDLE,
    errortype: data,
  };
};

export { storageScene, deviceStatus, errorHandle };
